export const PaisesConstants = {
  countries: [
    { name_es: 'Afganistán' },
    {
      name_es: 'Albania',
    },
    {
      name_es: 'Argelia',
    },
    {
      name_es: 'Samoa Americana',
    },
    {
      name_es: 'Andorra',
    },
    {
      name_es: 'Angola',
    },
    {
      name_es: 'Anguilla',
    },
    {
      name_es: 'Antártida',
    },
    {
      name_es: 'Antigua y Barbuda',
    },
    {
      name_es: 'Argentina',
    },
    {
      name_es: 'Armenia',
    },
    {
      name_es: 'Aruba',
    },
    {
      name_es: 'Australia',
    },
    {
      name_es: 'Austria',
    },
    {
      name_es: 'Azerbaiyán',
    },
    {
      name_es: 'Bahamas',
    },
    {
      name_es: 'Baréin',
    },
    {
      name_es: 'Banglades',
    },
    {
      name_es: 'Barbados',
    },
    {
      name_es: 'Bielorrusia',
    },
    {
      name_es: 'Bélgica',
    },
    {
      name_es: 'Belice',
    },
    {
      name_es: 'Benin',
    },
    {
      name_es: 'Bermudas',
    },
    {
      name_es: 'Butan',
    },
    {
      name_es: 'Bolivia',
    },
    {
      name_es: 'Bosnia-Herzegovina',
    },
    {
      name_es: 'Botsuana',
    },
    {
      name_es: 'Brasil',
    },
    {
      name_es: 'Territorio Británico del Océano Índico',
    },
    {
      name_es: 'Brunei',
    },
    {
      name_es: 'Bulgaria',
    },
    {
      name_es: 'Burkina Faso',
    },
    {
      name_es: 'Burundi',
    },
    {
      name_es: 'Camboya',
    },
    {
      name_es: 'Camerún',
    },
    {
      name_es: 'Canadá',
    },
    {
      name_es: 'Cabo Verde',
    },
    {
      name_es: 'Islas Caimán',
    },
    {
      name_es: 'República Centroafricana',
    },
    {
      name_es: 'Chad',
    },
    {
      name_es: 'Chile',
    },
    {
      name_es: 'China',
    },
    {
      name_es: 'Isla de Navidad',
    },
    {
      name_es: 'Islas Cocos',
    },
    {
      name_es: 'Colombia',
    },
    {
      name_es: 'Comoras',
    },
    {
      name_es: 'Congo',
    },
    {
      name_es: 'República Democrática del Congo',
    },
    {
      name_es: 'Islas Cook',
    },
    {
      name_es: 'Costa Rica',
    },
    {
      name_es: 'Costa de Marfil',
    },
    {
      name_es: 'Croacia',
    },
    {
      name_es: 'Cuba',
    },
    {
      name_es: 'Chipre',
    },
    {
      name_es: 'Chequia',
    },
    {
      name_es: 'Dinamarca',
    },
    {
      name_es: 'Yibuti',
    },
    {
      name_es: 'Dominica',
    },
    {
      name_es: 'República Dominicana',
    },
    {
      name_es: 'Ecuador',
    },
    {
      name_es: 'Egipto',
    },
    {
      name_es: 'El Salvador',
    },
    {
      name_es: 'Guinea Ecuatorial',
    },
    {
      name_es: 'Eritrea',
    },
    {
      name_es: 'Estonia',
    },
    {
      name_es: 'Etiopía',
    },
    {
      name_es: 'Islas Malvinas',
    },
    {
      name_es: 'Islas Feroe',
    },
    {
      name_es: 'Fiyi',
    },
    {
      name_es: 'Finlandia',
    },
    {
      name_es: 'Francia',
    },
    {
      name_es: 'Guayana Francesa',
    },
    {
      name_es: 'Polinesia Francesa',
    },
    {
      name_es: 'Gabón',
    },
    {
      name_es: 'Gambia',
    },
    {
      name_es: 'Georgia',
    },
    {
      name_es: 'Alemania',
    },
    {
      name_es: 'Ghana',
    },
    {
      name_es: 'Gibraltar',
    },
    {
      name_es: 'Grecia',
    },
    {
      name_es: 'Groenlandia',
    },
    {
      name_es: 'Granada',
    },
    {
      name_es: 'Guadalupe',
    },
    {
      name_es: 'Guam',
    },
    {
      name_es: 'Guatemala',
    },
    {
      name_es: 'Guernsey',
    },
    {
      name_es: 'Guinea',
    },
    {
      name_es: 'Guinea-Bisau',
    },
    {
      name_es: 'Guyana',
    },
    {
      name_es: 'Haití',
    },
    {
      name_es: 'Ciudad del Vaticano',
    },
    {
      name_es: 'Honduras',
    },
    {
      name_es: 'Hong Kong',
    },
    {
      name_es: 'Hungría',
    },
    {
      name_es: 'Islandia',
    },
    {
      name_es: 'India',
    },
    {
      name_es: 'Indonesia',
    },
    {
      name_es: 'Irán',
    },
    {
      name_es: 'Iraq',
    },
    {
      name_es: 'Irlanda',
    },
    {
      name_es: 'Isla de Man',
    },
    {
      name_es: 'Israel',
    },
    {
      name_es: 'Italia',
    },
    {
      name_es: 'Jamaica',
    },
    {
      name_es: 'Japón',
    },
    {
      name_es: 'Jersey',
    },
    {
      name_es: 'Jordania',
    },
    {
      name_es: 'Kazajistán',
    },
    {
      name_es: 'Kenia',
    },
    {
      name_es: 'Kiribati',
    },
    {
      name_es: 'Corea del Norte',
    },
    {
      name_es: 'Corea del Sur',
    },
    {
      name_es: 'Kosovo',
    },
    {
      name_es: 'Kuwait',
    },
    {
      name_es: 'Kirguistán',
    },
    {
      name_es: 'Laos',
    },
    {
      name_es: 'Letonia',
    },
    {
      name_es: 'Líbano',
    },
    {
      name_es: 'Lesoto',
    },
    {
      name_es: 'Liberia',
    },
    {
      name_es: 'Libia',
    },
    {
      name_es: 'Liechtenstein',
    },
    {
      name_es: 'Lituania',
    },
    {
      name_es: 'Luxemburgo',
    },
    {
      name_es: 'Macao',
    },
    {
      name_es: 'República de Macedonia',
    },
    {
      name_es: 'Madagascar',
    },
    {
      name_es: 'Malaui',
    },
    {
      name_es: 'Malasia',
    },
    {
      name_es: 'Maldivas',
    },
    {
      name_es: 'Malí',
    },
    {
      name_es: 'Malta',
    },
    {
      name_es: 'Islas Marshall',
    },
    {
      name_es: 'Martinica',
    },
    {
      name_es: 'Mauritania',
    },
    {
      name_es: 'Mauricio',
    },
    {
      name_es: 'Mayotte',
    },
    {
      name_es: 'México',
    },
    {
      name_es: 'Estados Federados de Micronesia',
    },
    {
      name_es: 'Moldavia',
    },
    {
      name_es: 'Monaco',
    },
    {
      name_es: 'Mongolia',
    },
    {
      name_es: 'Montenegro',
    },
    {
      name_es: 'Montserrat',
    },
    {
      name_es: 'Marruecos',
    },
    {
      name_es: 'Mozambique',
    },
    {
      name_es: 'Birmania',
    },
    {
      name_es: 'Namibia',
    },
    {
      name_es: 'Nauru',
    },
    {
      name_es: 'Nepal',
    },
    {
      name_es: 'Holanda',
    },
    {
      name_es: 'Antillas Holandesas',
    },
    {
      name_es: 'Nueva Caledonia',
    },
    {
      name_es: 'Nueva Zelanda',
    },
    {
      name_es: 'Nicaragua',
    },
    {
      name_es: 'Niger',
    },
    {
      name_es: 'Nigeria',
    },
    {
      name_es: 'Niue',
    },
    {
      name_es: 'IslaNorfolk',
    },
    {
      name_es: 'IslasMarianasdelNorte',
    },
    {
      name_es: 'Noruega',
    },
    {
      name_es: 'Omán',
    },
    {
      name_es: 'Pakistán',
    },
    {
      name_es: 'Palaos',
    },
    {
      name_es: 'Panamá',
    },
    {
      name_es: 'Papúa Nueva Guinea',
    },
    {
      name_es: 'Paraguay',
    },
    {
      name_es: 'Perú',
    },
    {
      name_es: 'Filipinas',
    },
    {
      name_es: 'Islas Pitcairn',
    },
    {
      name_es: 'Polonia',
    },
    {
      name_es: 'Portugal',
    },
    {
      name_es: 'Puerto Rico',
    },
    {
      name_es: 'Qatar',
    },
    {
      name_es: 'Rumania',
    },
    {
      name_es: 'Rusia',
    },
    {
      name_es: 'Ruanda',
    },
    {
      name_es: 'Reunion',
    },
    {
      name_es: 'San Bartolome',
    },
    {
      name_es: 'Santa Elena, Ascensión y Tristán de Acuña',
    },
    {
      name_es: 'San Cristóbal y Nieves',
    },
    {
      name_es: 'Santa Lucía',
    },
    {
      name_es: 'Isla de San Martín',
    },
    {
      name_es: 'San Pedro y Miquelon',
    },
    {
      name_es: 'San Vicente y las Granadinas',
    },
    {
      name_es: 'Samoa',
    },
    {
      name_es: 'San Marino',
    },
    {
      name_es: 'Santo Tomé y Príncipe',
    },
    {
      name_es: 'Arabia Saudita',
    },
    {
      name_es: 'Senegal',
    },
    {
      name_es: 'Serbia',
    },
    {
      name_es: 'Seychelles',
    },
    {
      name_es: 'Sierra Leona',
    },
    {
      name_es: 'Singapur',
    },
    {
      name_es: 'Eslovaquia',
    },
    {
      name_es: 'Eslovenia',
    },
    {
      name_es: 'Islas Salomón',
    },
    {
      name_es: 'Somalia',
    },
    {
      name_es: 'Sudáfrica',
    },
    {
      name_es: 'Sudán del Sur',
    },
    {
      name_es: 'España',
    },
    {
      name_es: 'Sri Lanka',
    },
    {
      name_es: 'Estado de Palestina',
    },
    {
      name_es: 'Sudán',
    },
    {
      name_es: 'Surinam',
    },
    {
      name_es: 'Svalbard y Jan Mayen',
    },
    {
      name_es: 'Suazilandia',
    },
    {
      name_es: 'Suecia',
    },
    {
      name_es: 'Suiza',
    },
    {
      name_es: 'Siria',
    },
    {
      name_es: 'Taiwán',
    },
    {
      name_es: 'Tayikistán',
    },
    {
      name_es: 'Tanzania',
    },
    {
      name_es: 'Tailandia',
    },
    {
      name_es: 'Timor Oriental',
    },
    {
      name_es: 'Togo',
    },
    {
      name_es: 'Tokelau',
    },
    {
      name_es: 'Tonga',
    },
    {
      name_es: 'Trinidad y Tobago',
    },
    {
      name_es: 'Túnez',
    },
    {
      name_es: 'Turquía',
    },
    {
      name_es: 'Turkmenistán',
    },
    {
      name_es: 'Islas Turcas y Caicos',
    },
    {
      name_es: 'Tuvalu',
    },
    {
      name_es: 'Uganda',
    },
    {
      name_es: 'Ucrania',
    },
    {
      name_es: 'Emiratos Árabes Unidos',
    },
    {
      name_es: 'Reino Unido',
    },
    {
      name_es: 'Estados Unidos',
    },
    {
      name_es: 'Uruguay',
    },
    {
      name_es: 'Uzbekistán',
    },
    {
      name_es: 'Vanuatu',
    },
    {
      name_es: 'Venezuela',
    },
    {
      name_es: 'Vietnam',
    },
    {
      name_es: 'Islas Vírgenes Británicas',
    },
    {
      name_es: 'Islas Vírgenes de los Estados Unidos',
    },
    {
      name_es: 'Wallis y Futuna',
    },
    {
      name_es: 'Yemen',
    },
    {
      name_es: 'Zambia',
    },
    {
      name_es: 'Zimbabue',
    },
    {
      name_es: 'Aland',
    },
  ],
};
